import React from "react";
import { useTranslation } from "react-i18next";

import { PlusTag } from "../../../../../../../../components/PlusTag";
import { ListCard, ListCardAction, VisibilityIcon } from "../../../../../../components/ListCard";
import { RowAction, RowActions } from "../../../../../../components/RowActions";
import { isPlusSection } from "../../../../sections";
import { getIcon } from "../../../IconStatusCard";

type Props = {
  sectionType: string;
  sectionSubtype?: string;
  active: boolean;
  // Only true while the user is inside the free×paid "review loop" (declined the
  // PLUS offer, sent back to /editor/sections?plusRequired=1 with sections still
  // active PLUS sections to remove/deactivate) - uses the solid PlusTag
  // variant so the sections that need attention stand out.
  showClassicPlusBadge?: boolean;
  onActiveClick: (active: boolean) => void;
  /** The section's "⋯": edit, send to another page, move, duplicate, delete. */
  actions: RowAction[];
  onClick: () => void;
};

/** A section of the list: its icon and name, then showing it or not (the eye) and its "⋯", as the pages' rows. */
const CardItem = ({
  sectionType,
  sectionSubtype,
  active,
  showClassicPlusBadge,
  onActiveClick,
  actions,
  onClick,
}: Props) => {
  const { t } = useTranslation();

  const handleActiveClick = (e: React.MouseEvent) => {
    onActiveClick(!active);
    e.stopPropagation();
  };

  const title = sectionSubtype
    ? t(`site.sections.${sectionType}.${sectionSubtype}`)
    : t(`site.sections.${sectionType}`);
  const toggleLabel = t(`pages.editor.sections.actions.${active ? "hide" : "show"}`);

  return (
    <ListCard
      title={title}
      titleExtra={isPlusSection(sectionType, sectionSubtype) && <PlusTag strong={showClassicPlusBadge} />}
      leading={getIcon(
        sectionType,
        active ? "var(--color-neutral-white)" : "var(--color-neutral-light)",
        sectionSubtype
      )}
      leadingVariant="icon"
      dimmed={!active}
      onClick={onClick}
      actions={
        <>
          <ListCardAction type="button" onClick={handleActiveClick} title={toggleLabel} aria-label={toggleLabel}>
            <VisibilityIcon visible={active} />
          </ListCardAction>
          <RowActions label={t("pages.editor.sections.actions.more", { title })} actions={actions} />
        </>
      }
    />
  );
};

export default CardItem;
